import React from "react";

const CloudLanding = () => {
  return (
    <div className="w-full h-screen bg-[#07001b]">
      <iframe
        title="MOO Sync Landing"
        src="/moosync-home.html"
        className="w-full h-full border-0"
        loading="eager"
      />
    </div>
  );
};

export default CloudLanding;
